import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const SummaryTable = ({ medicalStaff }) => {
  const tableHeader = [
    {
      field: "name",
      headerName: "name",
      width: 100,
      sortable: false,
      editable: false,
    },

    {
      field: "surname",
      headerName: "surname",
      width: 100,
      sortable: false,
      editable: false,
    },

    {
      field: "fiscalCode",
      headerName: "fiscal code",
      width: 150,
      sortable: false,
      editable: false,
    },

    {
      field: "email",
      headerName: "email",
      width: 200,
      sortable: false,
      editable: false,
    },

    {
      field: "password",
      headerName: "password",
      width: 150,
      sortable: false,
      editable: false,
    },

    {
      field: "validFrom",
      headerName: "valid from",
      width: 250,
      sortable: false,
      editable: false,
    },

    {
      field: "validTill",
      headerName: "valid till",
      width: 250,
      sortable: false,
      editable: false,
    },

    {
      field: "timestamp",
      headerName: "timestamp",
      width: 300,
      sortable: false,
      editable: false,
    },
  ];

  const [headerField, setHeaderField] = useState(tableHeader);
  const [bodyField, setBodyField] = useState([]);

  function generateRandom() {
    let length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    let i = 0,
      n = charset.length;
    for (; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  useEffect(() => {
    const body = medicalStaff.map((staff) => {
      return {
        id: generateRandom(),
        name: staff?.name,
        surname: staff?.surname,
        fiscalCode: staff?.fiscalCode,
        email: staff?.email,
        password: staff?.password,
        validFrom: staff?.validFrom,
        validTill: staff?.validTill,
        timestamp: staff?.timestamp,
      };
    });
    setBodyField(body);
  }, [medicalStaff]);
  return (
    <Box width="100%" height="100%">
      <DataGrid
        columns={headerField}
        rows={bodyField}
        hideFooterPagination={true}
        hideFooter={true}
        disableColumnMenu={true}
      />
    </Box>
  );
};

export default SummaryTable;
